import React from 'react'

/**
 * 
 * 
 * @param rules  a list of rules to check if true I.E {[toTestTrue1, toTestTrue2]}
 * @param ruleType "OR" defaults "AND"
 * @param exclude if true it reverses the results
 * @param arrayToCheck an array to check the rules against (TO IMPLEMENT)
 * @returns a div that is visible or not
 */

const VisDiv = ({children, className, onClick, style, rules=[], ruleType, exclude, arrayToCheck}) => {

    const ruleTypes = () => {
        
        switch (ruleType) {

            case "OR": {
                //process.env.NODE_ENV === "development" && console.log("OR")

                if(rules?.length > 0) {
                    //process.env.NODE_ENV === "development" && console.log("length > 0")
                    return rules.some((item)=>item)     
                }
                return true

            }                 
            default : {
                    //process.env.NODE_ENV === "development" && console.log("DEFAULT")

                    if(rules?.length > 0) {
                        //process.env.NODE_ENV === "development" && console.log("length > 0")
                        return rules?.every((item)=>item)  
                    }
                    return true
                }   
        }  
    }

    const isExlude = () => {
        if(!exclude){
            return ruleTypes()
        }
        return !ruleTypes()
    }

/*     const testFunction = () => {
        //process.env.NODE_ENV === "development" && console.log( ruleTypes() )
    } */

  return (
    <>
    {isExlude() && 
        <div className={className} style={style} onClick={onClick}>
            {/*<button onClick={testFunction}>test</button>*/}
            {children}
        </div>}
    </>
    
  )
}

export default VisDiv

export const BckgDiv = ({children, imgSource, className, style, overlayColor, overlayOpacity = 0.5}) => {
    return (
        <div 
            className={className}
            style={{
                backgroundImage: `url(${imgSource})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                ...style
            }}
        >
            {overlayColor && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: overlayColor,
                        opacity: overlayOpacity,
                        pointerEvents: 'none'
                    }}
                />
            )}
            <div style={{ position: 'relative', zIndex: 1 }}>
                {children}
            </div>
        </div>
    )
}
